class ComponentProductFormQuantity extends Theme.Component {
  constructor() {
    super();

    this.defineElementsAll({
      buttons: "button"
    });

    this.defineElements({
      input: "input"
    });
  }

  connectedCallback() {
    this.addEventListener("click", (event) => {
      event.preventDefault();

      const button = event.target.closest("button");

      if (!button) {
        return;
      }

      const new_value = Number(this.elements.input.value) + Number(button.dataset.value);

      if (new_value > 1) {
        this.elements.buttons.forEach((element) => {
          element.disabled = false;
        });
      }

      if (new_value == 1) {
        this.elements.buttons[0].disabled = true;
      }

      this.elements.input.value = new_value;
    });
  }
}

customElements.define("component-product-form-quantity", ComponentProductFormQuantity);
